"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Env = void 0;
// Module where environment variables may be housed and organized (vs accessing process.env.ENV_VAR
// directly). Specifically needed for injecting post-build env vars via __INJECT_VAR__ strings
// in the inject-build-params.sh script

var Env = {
  version: {
    tag: '__INJECT_BUILD_TAG__',
    branch: '__INJECT_GIT_BRANCH__',
    commit: '__INJECT_GIT_COMMIT__'
  }
};
exports.Env = Env;
window.MonumentEnv = Env;